module.exports = "<p>\n  investor-history works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/history/investor-history/investor-history.component.html
// module id = ./src/app/modules/history/investor-history/investor-history.component.html
// module chunks = main